@if (content?.message) {
<div class="w-12 p-t-7"
     *iCms="'message' of content; content: 'html'"></div>
}

<div class="flex flex-justify-center">
    <!-- title -->
    <button class="m-r-6 p-b-1 no-wrap-s h3"
            [ngClass]="!registerPageIsVisible ? 'col-1' : 'col-12'"
            type="button"
            cy-loginConfirm
            (click)="showRegisterForm(false)">
        <span>{{'Sign in' | translate}}</span>
    </button>

    <button class="p-b-1 no-wrap-s h3"
            [ngClass]="registerPageIsVisible ? 'col-1' : 'col-12'"
            type="button"
            cy-loginConfirm
            (click)="showRegisterForm(true)">
        <span>{{'Create an account' | translate}}</span>
    </button>
</div>

<form class="m-t-5 m-t-10-m m-t-10-s"
      method="POST"
      [attr.sl-form]="shouldRegister() ? 'register' : 'login'"
      #form="ngForm">

    <!-- email field (for all forms) -->
    <input-wrap>
        <input class="input"
               cy-loginMailInput
               [muiInput]="'Email address' | translate"
               sl-input="email"
               type="email"
               maxlength="100"
               validatePattern="email"
               name="email"
               [loqateEmail]="registerPageIsVisible"
               [attr.placeholder]="'Email address'"
               [(ngModel)]="tmpEmail"
               (ngModelChange)="applyTmpEmail()"
               (blur)="applyTmpEmail(true)"
               (keyup.enter)="applyTmpEmail(true)"
               autocomplete="username"
               required
               email
               #emailInput>
    </input-wrap>

    @if (shouldRegister() && registerPageIsVisible) {
    <p class="p1 m-t-6">
        {{'It looks like you don’t have an account with us. Enter your password to create an account.' | translate}}
    </p>
    }
    @if (shouldLogin() && !registerPageIsVisible) {
    <p class="p1 m-t-6">
        {{'It looks like you already have an account with us please enter your password to sign in.' | translate}}
    </p>
    }

    <!-- log in form -->
    @if (!registerPageIsVisible) {
    <div class="m-t-5 m-t-4-m m-t-4-s">
        <input-wrap class="block password-input">
            <input class="input"
                   type="password"
                   name="password"
                   cy-loginPwdInput
                   required
                   [muiInput]="'Password' | translate"
                   [(ngModel)]="data.password"
                   (keyup.enter)="login()">
        </input-wrap>
        <result class="block m-t p2"
                sl-result="login"
                cy-loginSignInMsg
                [status]="loginStatus"></result>
        <!-- action button -->
        <div class="m-t-6 m-t-5-m m-t-5-s">
            <!-- reset my password -->
            <action class=" button-inline-5"
                    sl-buton="reset"
                    [status]="passwordStatus"
                    (click)="resetPassword()">
                <span>{{'Forgot your password?' | translate}}</span>
            </action>
            <result class="block p2 col-3"
                    sl-result="reset"
                    [status]="passwordStatus"
                    [success]="'We have sent you an email with a link to reset your password.' | translate">
            </result>
            <action class="button w-12 m-t-10 m-t-9-s m-t-9-m"
                    sl-button="login"
                    cy-loginSignIn
                    [status]="loginStatus"
                    (click)="login()">
                <span>{{'Sign in' | translate}}</span>
            </action>
            @if(!isLoginPage) {
            <action class="button-1 w-12 m-t-2"
                    (click)="router.navigate(['/'])">
                <span>{{'Back to shopping' | translate}}</span>
            </action>
            }
        </div>
        <social-login *ifNotStandalone></social-login>
    </div>
    }

    <!-- create account form -->
    @if (registerPageIsVisible) {
    <div class="register-form">
        <!-- first name -->
        <input-wrap class="block m-t-5 m-t-4-m m-t-4-s">
            <input class="input"
                   type="text"
                   name="firstname"
                   required
                   sl-input="firstname"
                   cy-registerFnameInput
                   [(ngModel)]="registerData.firstname"
                   [muiInput]="'First name' | translate">
        </input-wrap>
        <!-- last name -->
        <input-wrap class="block m-t-5 m-t-4-m m-t-4-s">
            <input class="input"
                   type="text"
                   name="lastname"
                   required
                   sl-input="lastname"
                   cy-registerLnameInput
                   [(ngModel)]="registerData.lastname"
                   [muiInput]="'Last name' | translate">
        </input-wrap>
        <!-- password -->
        <p class="p1 m-t-7 m-t-10-m m-t-10-s">{{'Enter a password below to create an account.' | translate}}</p>
        <input-wrap class="block m-t-5 m-t-4-m m-t-4-s password-input">
            <input class="input"
                   type="password"
                   [name]="'password'"
                   required
                   [attr.placeholder]="'Password' | translate"
                   reverse="true"
                   [(ngModel)]="registerData.password"
                   [muiInput]="'Password' | translate">
        </input-wrap>
        <input-wrap class="block m-t-5 m-t-4-m m-t-4-s m-b password-input"
                    [messages]="{validateEqual: ('Password and its confirmation do not match' | translate)}">
            <input class="input"
                   type="password"
                   [name]="'confirmPassword'"
                   required
                   [attr.placeholder]="'Password' | translate"
                   [matchCheck]="'password'"
                   [(ngModel)]="registerData.confirmPassword"
                   [muiInput]="'Confirm password' | translate">
        </input-wrap>

        <!-- opt in -->
        <p class="s1 flex flex-middle p-t-10">
            <i class="icon-contact fs-7 m-r-2"></i>
            <span>{{'Sign up to our newsletter' | translate}}</span>
        </p>
        <p class="p2 m-t-2 m-t-1-m m-t-1-s">
            <span class="m-r-1">
                {{'By signing up to receive our newsletter you accept our'| translate}}
            </span>
            <a class="cursor-pointer"
               [routerLink]="'/customer-service/privacy'"
               target="_blank">{{'Privacy policy' | translate}}</a>
            <span class="m-l-1 m-r-1">{{'and' | translate}}</span>
            <a class="cursor-pointer"
               [routerLink]="'/customer-service/terms'"
               target="_blank">{{'Terms & Conditions' | translate}}</a>.
        </p>
        <radio-group class="block m-t m-b left flex"
                     [name]="'newsletter'"
                     [value]="newsletterPreselection"
                     [(ngModel)]="registerData.newsletter">
            <div class="w-5 w-6-s left m-r-3-m m-r-3-s">
                <radio value="1">
                    <span class="p-l-2 s2">{{'Yes, please' | translate}}</span>
                </radio>
            </div>
            <div class="w-5 w-6-s left">
                <radio value="0">
                    <span class="p-l-2 s2">{{'No, thanks' | translate}}</span>
                </radio>
            </div>
        </radio-group>
        @if (showLoyaltyTerms) {
        <div class="m-t-10">
            @if (loyaltyDescription) {
            <p class="p2"
               [innerHTML]="loyaltyDescription"></p>
            }
            <input-wrap class="m-t-2 block left">
                <checkbox required
                          [name]="'loyaltyTerms'"
                          [checked]="registerData.loyaltyTerms || false"
                          [(ngModel)]="registerData.loyaltyTerms">
                    <span class="s2">{{loyaltyTitle}}</span>
                </checkbox>
            </input-wrap>
        </div>
        }
        <!-- login button -->
        <action class="button w-12 m-t-10 m-t-9-m m-t-9-s"
                sl-button="login"
                cy-loginSignUp
                [status]="registerStatus"
                [class.disabled]="showLoyaltyTerms && !registerData.loyaltyTerms"
                (click)="register()">
            <span>{{'Create account' | translate}}</span>
        </action>
        <result class="block m-b-2 p2 m-t-1"
                sl-result="login"
                cy-loginSignUpMsg
                [status]="registerStatus"></result>
    </div>
    }
</form>
